import * as React from "react";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z"
      fill="#2F80ED"
    />
    <G clipPath="url(#clip0_2936_2216)">
      <Path
        d="M20.5341 18.4089C20.2918 18.2286 19.9492 18.279 19.7689 18.5213C19.6698 18.6545 19.5637 18.7853 19.4536 18.9098C19.2535 19.1361 19.2748 19.4817 19.5011 19.6818C19.6051 19.7737 19.7343 19.8189 19.8631 19.8189C20.0143 19.8189 20.1649 19.7565 20.273 19.6342C20.4034 19.4867 20.529 19.3319 20.6465 19.1741C20.8267 18.9318 20.7764 18.5892 20.5341 18.4089Z"
        fill="white"
      />
      <Path
        d="M21.4487 15.8447C21.1538 15.7804 20.8623 15.9676 20.798 16.2627C20.7627 16.425 20.72 16.5877 20.671 16.7462C20.5818 17.0347 20.7435 17.3409 21.0321 17.4301C21.0858 17.4467 21.1402 17.4546 21.1937 17.4546C21.4272 17.4546 21.6434 17.3038 21.716 17.069C21.7741 16.8809 21.8248 16.6879 21.8668 16.4953C21.931 16.2002 21.7438 15.9089 21.4487 15.8447Z"
        fill="white"
      />
      <Path
        d="M17.9025 20.1613C17.7573 20.2423 17.607 20.3181 17.4557 20.3864C17.1804 20.5107 17.0581 20.8346 17.1824 21.1099C17.2737 21.3121 17.4728 21.4318 17.6811 21.4318C17.7564 21.4318 17.8328 21.4162 17.9059 21.3832C18.0853 21.3022 18.2636 21.2123 18.4357 21.1162C18.6994 20.969 18.7939 20.6358 18.6466 20.3721C18.4994 20.1085 18.1662 20.014 17.9025 20.1613Z"
        fill="white"
      />
      <Path
        d="M14.4526 10.625V14.7735L12.4473 16.7788C12.2337 16.9924 12.2337 17.3387 12.4473 17.5522C12.5541 17.659 12.694 17.7124 12.834 17.7124C12.9739 17.7124 13.1139 17.659 13.2207 17.5522L15.3862 15.3867C15.4888 15.2842 15.5464 15.145 15.5464 15V10.625C15.5464 10.323 15.3016 10.0781 14.9995 10.0781C14.6975 10.0781 14.4526 10.323 14.4526 10.625Z"
        fill="white"
      />
      <Path
        d="M21.4531 9.17578C21.1511 9.17578 20.9062 9.42062 20.9062 9.72266V11.2412C19.6333 9.24491 17.4104 8 15 8C13.1302 8 11.3724 8.72814 10.0502 10.0502C8.72814 11.3724 8 13.1302 8 15C8 16.8698 8.72814 18.6276 10.0502 19.9498C11.3724 21.2719 13.1302 22 15 22C15.0046 22 15.0091 21.9994 15.0137 21.9993C15.0183 21.9994 15.0227 22 15.0273 22C15.2244 22 15.4235 21.9917 15.619 21.9753C15.92 21.9501 16.1435 21.6857 16.1183 21.3847C16.0931 21.0838 15.829 20.8601 15.5277 20.8854C15.3624 20.8992 15.1941 20.9062 15.0273 20.9062C15.0227 20.9062 15.0183 20.9068 15.0137 20.9069C15.0091 20.9068 15.0046 20.9062 15 20.9062C11.7433 20.9062 9.09375 18.2567 9.09375 15C9.09375 11.7433 11.7433 9.09375 15 9.09375C17.0989 9.09375 19.0293 10.2125 20.0842 11.9922H18.5805C18.2784 11.9922 18.0336 12.237 18.0336 12.5391C18.0336 12.8411 18.2784 13.0859 18.5805 13.0859H20.25C20.583 13.0859 20.8946 12.9923 21.1599 12.8302C21.177 12.8205 21.1934 12.81 21.209 12.7987C21.685 12.4856 22 11.947 22 11.3359V9.72266C22 9.42062 21.7552 9.17578 21.4531 9.17578Z"
        fill="white"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_2936_2216">
        <Rect width={14} height={14} fill="white" transform="translate(8 8)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
